// import all pngs from a directory
import analytics from '../assets/analytics.png';
import bug from '../assets/bug.png';
import logoOnly from '../assets/Logo_only.png';
import orange from '../assets/orange.png';
import pp1 from '../assets/pp1.png';
import pp2 from '../assets/pp2.png';
import s1color from '../assets/s1-color.png';
import s1light from '../assets/s1-light.png';
import s2color from '../assets/s2-color.png';
import s2light from '../assets/s2-light.png';
import s3color from '../assets/s3-color.png';
import s3light from '../assets/s3-light.png';
import s4color from '../assets/s4-color.png';
import s4light from '../assets/s4-light.png';
import s5color from '../assets/s5-color.png';
import s5light from '../assets/s5-light.png';
import s6color from '../assets/s6-color.png';
import s6light from '../assets/s6-light.png';
import support from '../assets/support.png';
import teliviLogo from '../assets/Telivi-logo.png';

function importAll(r) {
  let images = {analytics, bug, logoOnly, orange, pp1, pp2, s1color, s1light, s2color, s2light, s3color, s3light, s4color, s4light, s5color, s5light, s6color, s6light, support, teliviLogo};
  r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const assets = importAll(require.context('./', false, /\.(png|jpe?g|svg)$/));
    
export default assets;
